import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { GlobalService } from '../../../shared/global.service';
import { PropertyService } from '../../../views/app/properties/property.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { HelperService } from '../../../shared/helper.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-rental-incoms',
  templateUrl: './add-rental-incoms.component.html',
  styleUrls: ['./add-rental-incoms.component.scss']
})
export class AddRentalIncomsComponent implements OnInit {
  @ViewChild('content', { static: false }) public content!: ModalDirective;
  
  @Input() properties: any = {};
  @Input() propertyRef: string = '';
  @Input() rentalHeader: any = {};
  @Input() supplier_id: any;
  @Input() supplier: string = '';
  @Input() isEdit: boolean = false;
  @Input() selectedRental: any = [];
  
  @Output() closeModalEvent = new EventEmitter();
  @Output() saveSuccessEvent = new EventEmitter();
  
  rentalForm!: FormGroup;
  dataArray!: FormArray;
  private _rentalArray: any[] = [];
  @Input()
  get rentalArray(): any[] {
    return this._rentalArray;
  }
  set rentalArray(value: any[]) {
    this._rentalArray = Array.isArray(value) ? value : (value ? [value] : []);
    // Defer patch so it runs after ngOnInit (dataArray is ready)
    setTimeout(() => this.applyPendingPatch(), 0);
  }
  
  responseWaiting = '';
  responseWaiting1 = '';
  buttonDisabled = false;
  buttonDisabled1 = false;
  hiddenModal = false;
  showMissingBtn = false;
  
  pdfFiles: File[] = [];
  showPdfFiles: any[] = [];
  selectedFile: any;
  selectedFileLength: any;
  pdfs: any[] = [];
  pdfCount = 0;
  showpdfcount = 0;
  status: any;
  row_key: any;
  deleteExpenseRef: any = [];
  randomString = '';
  dateList: any = [];
  formData: any = [];
  dataExpenses: any = [];
  dataMedia: any = [];
  agentFee = null;
  
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private notifications: NotificationsService,
    private globeService: GlobalService,
    private propertyService: PropertyService,
    private spinner: NgxSpinnerService,
    private helperService: HelperService,
    private activeModel: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.applyPendingPatch();
    if (this.propertyRef != "" && this.propertyRef != null) {
      this.getPropertyRentalData();
    }
  }

  /** Applies rentalArray into dataArray when both are ready. */
  private applyPendingPatch(): void {
    if (this._rentalArray?.length && this.dataArray) {
      this.patchDataArray(this._rentalArray);
    }
  }
  
  initializeForm() {
    this.rentalForm = this.fb.group({
      property_ref: [this.propertyRef],
      rental_detail_ref: [this.selectedRental?.rental_detail_ref || ''],
      dataArray: this.fb.array([])
    });
    
    this.dataArray = this.rentalForm.get('dataArray') as FormArray;
  }
  
  createRentalRow(data?: any): FormGroup {
    return this.fb.group({
      date_s: [data?.date_s || '', Validators.required],
      amount: [data?.amount || '', Validators.required],
      name: [data?.name || ''],
      media: this.fb.array(data?.media || []),
      error_count: [data?.error_count || 0],
      error_amount: [data?.error_amount || 0],
      randomStr: [data?.randomStr || this.randomStringGenerator()],
      expenses: this.fb.array(data?.expenses || [])
    });
  }
  
  createMediaGroup(media?: any): FormGroup {
    return this.fb.group({
      full_url: [media?.full_url || ''],
      media_ref: [media?.media_ref || ''],
      file_name: [media?.file_name || ''],
      type: [media?.type || ''],
      randomStr: [media?.randomStr || this.randomStringGenerator()]
    });
  }
  
  addNewRow(full_url = '', media_ref = '', file_name = '', type = '') {
    const mediaArray = this.fb.array([]);
    if (full_url && media_ref && file_name && type) {
      mediaArray.push(this.createMediaGroup({ full_url, media_ref, file_name, type }));
    }
    
    const newRow = this.createRentalRow({
      media: mediaArray.value,
      expenses: []
    });
    
    this.dataArray.push(newRow);
  }
  
  addRow(key: number, row: any) {
    const newRow = this.createRentalRow({
      amount: row.value.amount || this.rentalHeader?.rent_per_month,
      name: row.value.name || this.rentalHeader?.tenant
    });
    
    this.dataArray.insert(key + 1, newRow);
  }
  
  removeRecord(randomStr: string) {
    const index = this.dataArray.value.findIndex((x: any) => x.randomStr === randomStr);
    
    if (index > -1) {
      // Update dates for rows after the removed one
      const updatedRows = this.dataArray.value.map((row: any, rowIndex: number) => {
        if (rowIndex > index && row.date_s) {
          const date = new Date(this.helperService.extractDateString(row.date_s));
          date.setMonth(date.getMonth() - 1);
          return { ...row, date_s: this.helperService.formDateObject(date) };
        }
        return row;
      });
      
      this.dataArray.clear();
      updatedRows.forEach((row: any) => this.dataArray.push(this.createRentalRow(row)));
    }
  }
  
  validateField(row: any, event: any) {
    if (!row.value.date_s) {
      row.patchValue({ error_count: 1 });
    } else {
      row.patchValue({ error_count: 0 });
    }
  }
  
  validateAmount(row: any, event: any) {
    if (row.value.amount) {
      row.patchValue({ error_amount: 0 });
    } else {
      row.patchValue({ error_amount: 1 });
    }
  }
  
  amountChange(key: number, amount: any) {
    for (let i = key; i < this.dataArray.length; i++) {
      this.dataArray.at(i).patchValue({ amount });
    }
  }
  
  tenantChange(key: number, name: any) {
    for (let i = key; i < this.dataArray.length; i++) {
      this.dataArray.at(i).patchValue({ name });
    }
  }
  
  savePdfs(event: any, status: string, row_key: number) {
    this.status = status;
    this.row_key = row_key;
    this.pdfFiles = [];
    this.pdfCount = 0;
    if (event && event.addedFiles) {
      this.showPdfFiles.push(...event.addedFiles);
      this.pdfFiles.push(...event.addedFiles);
    }
    this.addPdfSelected(event, this.pdfFiles);
  }
  
  async addPdfSelected(event: any, files: any[]) {
    this.selectedFile = files;
    this.selectedFileLength = Object.keys(this.selectedFile).length;
    let formData = new FormData();
    
    for (let i = 0; i < this.selectedFileLength; i++) {
      formData.append('file', this.selectedFile[i], this.selectedFile[i].name);
      await this.pushPdfs(formData, this.selectedFile[i].name);
    }
  }
  
  pushPdfs(formData: FormData, file_name: string) {
    this.spinner.show();
    this.responseWaiting = 'show-spinner';
    
    this.globeService.commonFileUploader(formData).subscribe((suc: any) => {
      this.pdfs[this.pdfCount] = { src: suc['full_url'] };
      this.pdfs[this.pdfCount]['media_ref'] = suc['media_ref'];
      this.pdfs[this.pdfCount]['thumb'] = suc['thumb'];
      this.pdfs[this.pdfCount]['type'] = suc['type'];
      
      if (this.status == 'row_pdf') {
        const row = this.dataArray.at(this.row_key);
        const mediaArray = row.get('media') as FormArray;
        mediaArray.push(this.createMediaGroup({
          full_url: suc['full_url'],
          media_ref: suc['media_ref'],
          file_name: file_name,
          type: suc['type']
        }));
      }
      
      this.pdfCount++;
      this.showpdfcount++;
      this.spinner.hide();
      this.responseWaiting = '';
    }, (err: any) => {
      this.onError(err.statusText);
    });
  }
  
  removePdfRental(key: number, file_name: string, key_media: number) {
    const row = this.dataArray.at(key);
    const mediaArray = row.get('media') as FormArray;
    
    if (mediaArray.at(key_media)) {
      mediaArray.at(key_media).patchValue({
        media_ref: '',
        full_url: '',
        file_name: '',
        type: ''
      });
    }
    
    const pdfIndex = this.showPdfFiles.findIndex((x: any) => x.name === file_name);
    if (pdfIndex !== -1) {
      this.showPdfFiles.splice(pdfIndex, 1);
      this.pdfFiles.splice(pdfIndex, 1);
    }
  }
  
  mediaDownload(fileData: any) {
    const data = {
      media_ref: fileData['media_ref']
    };
    
    this.spinner.show();
    this.globeService.mediaDownload(data).subscribe((data: any) => {
      const blob = new Blob([data], { type: fileData['type'] });
      this.spinner.hide();
      importedSaveAs(blob, fileData['real_name']);
    }, (err: any) => {
      this.spinner.hide();
      this.globeService.unauthorizedRequest(err.status);
    });
  }
  
  /**
   * Patches an array of rental data into the dataArray FormArray.
   * Use when opening in edit mode or when rentalArray is set from parent (e.g. API or AI assistance).
   * Accepts either an array or a single object (normalized to array).
   */
  patchDataArray(data: any) {
    if (!data || !this.dataArray) return;
    const list = Array.isArray(data) ? data : [data];
    this.dataArray.clear();
    list.forEach((item: any) => {
      const dateForPicker = item.paid_date != null
        ? this.helperService.formDateObject(item.paid_date)
        : (item.date_s || '');
      const rowData = {
        date_s: dateForPicker,
        amount: item.amount ?? item.rent_payment ?? this.rentalHeader?.rent_per_month ?? '',
        name: item.name ?? item.tenant_name ?? this.rentalHeader?.tenant ?? '',
        error_count: item.error_count ?? 0,
        error_amount: item.error_amount ?? 0,
        randomStr: item.randomStr ?? this.randomStringGenerator(),
        media: [],
        expenses: item.expenses ?? []
      };
      const row = this.createRentalRow(rowData);
      const mediaArray = row.get('media') as FormArray;
      mediaArray.clear();
      (item.media || []).forEach((m: any) => mediaArray.push(this.createMediaGroup(m)));
      this.dataArray.push(row);
    });
  }

  createMissingRentals(content: any) {
    if (this.dateList.length > 0) {
      this.showMissingBtn = false;
      this.dataArray.clear();
      this.dateList.forEach((element: any) => {
        this.dataArray.push(this.createRentalRow(element));
      });
    }
  }
  
  addNewRentalDetailSubmit(content: any) {
    if (this.rentalForm.invalid || this.buttonDisabled) {
      this.markFormGroupTouched(this.rentalForm);
      return;
    }
    
    this.buttonDisabled = true;
    this.responseWaiting = 'show-spinner';
    this.formData = [];
    
    const formValue = this.rentalForm.value;
    formValue.deleteExpenseRefs = this.deleteExpenseRef;
    formValue.tenant = this.rentalHeader?.tenant || '';
    
    this.formData.push(formValue);
    
    // Process data array
    for (let i = 0; i < formValue.dataArray.length; i++) {
      if (formValue.dataArray[i].date_s) {
        formValue.dataArray[i].date = this.helperService.extractDateString(formValue.dataArray[i].date_s);
        formValue.dataArray[i].supplier_id = this.supplier_id;
        formValue.dataArray[i].business_name = this.rentalHeader?.business_name || '';
      }
    }
    
    this.formData.push(formValue.dataArray);
    
    this.propertyService.saveRentalDetail(this.formData).subscribe((response: any) => {
      this.responseWaiting = '';
      this.buttonDisabled = false;
      
      if (response['status'] === 200) {
        this.onSuccess('Save Successful!');
        this.closeModel(true);
        this.saveSuccessEvent.emit(response);
      } else {
        this.onError('Something went wrong');
      }
    }, (err: any) => {
      this.onError(err.message);
      this.buttonDisabled = false;
      this.globeService.unauthorizedRequest(err.status);
    });
  }
  
  addNewRentalDetailCreateExpensesSubmit(content: any) {
    if (this.rentalForm.invalid || this.buttonDisabled1) {
      this.markFormGroupTouched(this.rentalForm);
      return;
    }
    
    this.buttonDisabled1 = true;
    this.responseWaiting1 = 'show-spinner';
    this.formData = [];
    
    const formValue = this.rentalForm.value;
    formValue.deleteExpenseRefs = this.deleteExpenseRef;
    formValue.tenant = this.rentalHeader?.tenant || '';
    
    this.formData.push(formValue);
    
    // Process data array
    for (let i = 0; i < formValue.dataArray.length; i++) {
      if (formValue.dataArray[i].date_s) {
        formValue.dataArray[i].date = this.helperService.extractDateString(formValue.dataArray[i].date_s);
        formValue.dataArray[i].supplier_id = this.supplier_id;
        formValue.dataArray[i].business_name = this.rentalHeader?.business_name || '';
      }
    }
    
    this.formData.push(formValue.dataArray);
    
    this.propertyService.saveRentalDetail(this.formData).subscribe((response: any) => {
      this.responseWaiting1 = '';
      this.buttonDisabled1 = false;
      
      if (response['status'] === 200) {
        this.onSuccess('Save Successful!');
        this.closeModel(true);
        // Emit event to open expense modal
        this.saveSuccessEvent.emit({ ...response, openExpenses: true });
      } else {
        this.onError('Something went wrong');
      }
    }, (err: any) => {
      this.onError(err.message);
      this.buttonDisabled1 = false;
      this.globeService.unauthorizedRequest(err.status);
    });
  }
  

  closeModel(success?: boolean) {
    if (success) {
      this.activeModel.close(true);
    } else {
      this.activeModel.dismiss();
    }
  }
  
  openReportNewIssueModal(type: string) {
    // Implement report issue functionality
    console.log('Report issue for:', type);
  }
  
  randomStringGenerator(): string {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    let text = '';
    for (let i = 0; i < 4; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  
  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else if (control instanceof FormArray) {
        control.controls.forEach(arrayControl => {
          if (arrayControl instanceof FormGroup) {
            this.markFormGroupTouched(arrayControl);
          } else {
            arrayControl.markAsTouched();
          }
        });
      }
    });
  }
  
  onSuccess(message: string) {
    this.notifications.create('Success', message, NotificationType.Success, {
      theClass: 'outline primary',
      timeOut: 6000,
      showProgressBar: true
    });
  }
  
  onError(message: string) {
    this.notifications.create('Error', message, NotificationType.Error, {
      theClass: 'outline primary',
      timeOut: 6000,
      showProgressBar: true
    });
  }

  getPropertyRentalData() {
    // this.openRentalModel(this.rentalModel);
    this.spinner.show();
    this.globeService.menuLoadingEvent(true);

    let data = {
      // 'from_date': this.fromDate,
      'from_date': "",
      // 'to_date': this.toDate,
      'to_date': "",
      'table_filter': "",
      'picklistValue': "0",
      'page_size': 10,
      'page_no': 1,
      // 'rental_id': this.rentalHeader['rental_id'],
      'property_ref': this.propertyRef,
    };

    this.propertyService.getPropertyRentalByRef(data).subscribe(response => {
      this.rentalHeader =[];
      this.properties = response['properties'];
      this.rentalHeader = response['rental_header'];

      let permissionData ={
        permission_list:response['user_permissions'],
        snapShotVisibility:response['snapShot_validation']
      }

      this.propertyRef = response['properties']['property_ref'];
      if (response['rental_header'] != null) {
        this.rentalHeader = response['rental_header'];
        }


        this.supplier_id = response['rental_header']['supplier_id'];
        this.supplier = response['rental_header']['business_name'];
      this.spinner.hide();

    }, err => {
      this.globeService.menuLoadingEvent(false);
      this.onError(err.message);
      this.spinner.hide();
    });
  }


}
